
/*
 * views/cartView.js
 * Cart View
 */

define( 'app/views/cartView',[
    'lib/event',
    'app/views/commonViewHelper',
    'Handlebars',
    'hbs!app/views/templates/navbar',
    'hbs!app/views/templates/breadcrumbs',
    'hbs!app/views/templates/content',
    'hbs!app/views/templates/cartSummary',
    'hbs!app/views/templates/bookingHistory',
    'hbs!app/views/templates/cartCCPaymentForm',
    'hbs!app/views/templates/cartCCPaymentResult',
    'hbs!app/views/templates/processingPPPayment',
    'hbs!app/views/templates/cartYPForm',
    'hbs!app/views/templates/redirectYP',
    'hbs!app/views/templates/redirectPaytm',
    'hbs!app/views/templates/redirectI4G',
    'hbs!app/views/templates/redirect3DS',
    'hbs!app/views/templates/redirectFP',
    'hbs!app/views/templates/redirectWP',
    'hbs!app/views/templates/redirectSQ',
    'hbs!app/views/templates/redirect3C',
    'hbs!app/views/templates/analytics',
    'hbs!app/views/templates/acceptTermsModal',
    'hbs!app/views/templates/cartGCRedeem',
    'bootstrap',
    'app/views/templates/helpers/escapeJSString',
    'app/views/templates/helpers/isEqual'
], function(  Event, commonViewHelper, Handlebars, navbarTpl, breadcrumbsTpl, contentTpl, cartSummaryTpl,
              bookingHistoryTpl, cartCCPaymentFormTpl, cartCCPaymentResultTpl, processingPPPaymentTpl, cartYPFormTpl, 
              redirectYPTpl, redirectPaytmTpl, redirectI4GTpl, redirect3DSTpl, redirectFPTpl, redirectWPTpl, redirectSQTpl, 
              redirect3CTpl, analyticsTpl, acceptTermsModalTpl, cartGCRedeemTpl ){
    var cartView = {
        app : app,
        event: $.extend({},Event),
        module : "summary"
    };
    var setBreadCrumb = function( crumbText, crumbLink ) {
        app.data.breadCrumbs = app.data.breadCrumbs || {};
        app.data.breadCrumbs.cart = app.data.breadCrumbs.cart || [];
        var spliceCrumbsAt = -1,
            existingCrumb = $.grep(app.data.breadCrumbs.cart,function(crumb,index){
                if (crumb.url==crumbLink) {
                    spliceCrumbsAt = index;
                    return true;
                }
                return false;
            }),
            currentCrumb = {name:crumbText,url:crumbLink};

        app.data.breadCrumbs.cart = existingCrumb.length ?
            $.merge(app.data.breadCrumbs.cart.slice(0,spliceCrumbsAt),[currentCrumb]) :
            $.merge(app.data.breadCrumbs.cart,[currentCrumb]);

        for(var i=0;i<app.data.breadCrumbs.cart.length;i++) {
            app.data.breadCrumbs.cart[i].last = i==(app.data.breadCrumbs.cart.length-1);
        }
    };

    cartView.event.listen('showCartContents', cartView, function(e, cartData, specialServices){
        app.datal('cartData', cartData)

        if(cartData.WebFolioItem != undefined){
        for(var i=0;i< cartData.WebFolioItem.length;i++){
                _.each(app.data.BookedEquipmentDetails, function(v,k){
                if(cartData.WebFolioItem[i].FolioItemId == k ){
                    cartData.WebFolioItem[i].equipment = v
                }
                })
                if(cartData.WebFolioItem[i].Category == "SpaWait") { //add missing fields
                    cartData.WebFolioItem[i].equipment = app.localization.bookingSummaryV2.guestWaitListEquipment 
                    cartData.WebFolioItem[i].ItemClass = "C"

                    $.when(app.models.spaModel.getData('spaLocations')).then(function(val){
                    _.each(val.SpaLocation,function(loc){
                        if(loc.LocationId ==cartData.WebFolioItem[i].Location ){
                            cartData.WebFolioItem[i].LocationName = loc.LocationName
                        }
                    })
                })
                }
            }
        }

        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };

        var golfGrouped = {},
            newItems = [],
            balance = app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId}),
            guestNoteSpecialService = null;
        _.each(cartData.WebFolioItem, function(v,k,l){
            if (v.Category=="Golf") {
                var groupMembers = app.data.groupMembers && app.data.groupMembers.GroupMember ? app.data.groupMembers.GroupMember : [];
                var isPrivate = !((v.CustomerId == app.data.CustomerId || _.find(groupMembers, function(member){ return member.CustomerId == v.CustomerId })) || !app.customization.golfBooking.memberPrivacyMode);

                if (golfGrouped[v.FolioId]) {
                    golfGrouped[v.FolioId].Amount += +v.Amount;
                    golfGrouped[v.FolioId].Players += 1;
                    // group members from roster modal
                    if(app.customization.golfBooking.enableGolfMemberRoster){
                        //check if player is a group member or primary user -- all other players are club members
                        if(isPrivate){
                            golfGrouped[v.FolioId].playerGroup.push({CustomerId:v.CustomerId, Name:v.CustomerName, Details:app.localization.golf.modal.memberRate});
                        } else {
                            golfGrouped[v.FolioId].playerGroup.push({CustomerId:v.CustomerId, Name:v.CustomerName, Amount:v.Amount, Details:v.Details});
                        }
                        // Setting name to primary user's name
                        golfGrouped[v.FolioId].CustomerName =  app.data.FirstName + ', ' + app.data.LastName;
                        // Replacing with primary user's ID for grouping
                        golfGrouped[v.FolioId].CustomerId = app.data.CustomerId;
                    }
                } else {
                    golfGrouped[v.FolioId] = v;
                    golfGrouped[v.FolioId].Players = 1;
                    golfGrouped[v.FolioId].EachAmount = +v.Amount;
                    golfGrouped[v.FolioId].Amount = +v.Amount;
                    //group members from roster modal
                    if(app.customization.golfBooking.enableGolfMemberRoster){
                        //check if player is a group member or primary user - all other users are club members
                        if(isPrivate){
                            golfGrouped[v.FolioId].playerGroup = [{CustomerId:v.CustomerId, Name:v.CustomerName, Details:app.localization.golf.modal.memberRate}];
                        } else {
                            golfGrouped[v.FolioId].playerGroup = [{CustomerId:v.CustomerId, Name:v.CustomerName, Amount:v.Amount, Details:v.Details}];
                        }
                         // Setting name to primary user's name
                         golfGrouped[v.FolioId].CustomerName =  app.data.FirstName + ', ' + app.data.LastName;
                         // Replacing with primary user's ID for grouping
                         golfGrouped[v.FolioId].CustomerId = app.data.CustomerId;
                    }
                }
                
                delete l[k];
            } else if (v.specialServicesAvailable) {
                var newSpecialServicesAvailable = [];
                _.each(v.specialServicesAvailable, function(vv,kk,ll){
                    if (vv.IsCharged=='1') {
                        var startDate = Date.parseExact(v.StartDate, "yyyy-MM-ddHHmmss"),
                            endDate = Date.parseExact(v.FinishDate, "yyyy-MM-ddHHmmss");
                        vv.dateList = [];
                        for (var theDate = startDate.clone(); theDate < endDate; theDate.add(1).day()) {
                            vv.dateList.push({
                                human:theDate.toString(app.localization.CultureInfo.formatPatterns.longDate),
                                machine:theDate.toString("yyyy-MM-dd")
                            });
                        }
                    }
                    if (v.pmsVenue && v.pmsVenue.GuestNoteServiceName == vv.PMSSpecialServiceName) {
                        v.guestNoteSpecialService = vv;
                    } else {
                        newSpecialServicesAvailable.push(vv);
                    }
                });
                v.specialServicesAvailable = newSpecialServicesAvailable;
                if (_.any(app.data.pmsDayBookings,function(x){return x==v.FolioId})) {
                    v.isDayBooking = true;
                }
                v.PreDepositAmount = v.FolioTotal;
                newItems.push(v);
            } else {
                if (v.Category=="Hotel" && _.any(app.data.pmsDayBookings,function(x){return x==v.FolioId})) {
                    v.isDayBooking = true;
                }
                v.PreDepositAmount = v.FolioTotal;
                if (v.Category=="Spa"||v.Category=="Ski") {
                    v.PreDepositAmount = v.Amount;
                    v.Amount = (v.FolioPayments == 0) ? v.Amount : v.Amount / v.FolioTotal * v.FolioPayments

                }
                if (v.Category=="Ski") {
                    var guestRequest = app.data.skiGuestNotes && app.data.skiGuestNotes[v.FolioItemId]
                    v.guestRequest = guestRequest;
                    if(v.FinishDate){
                        v.FinishDate = Date.parseExact(v.FinishDate.substr(0,10), "yyyy-MM-dd").add(-1).days().toString('yyyy-MM-dd') + v.FinishDate.substr(10)
                    }
                }
                if (v.Category=="Spa") {  
                    var guestRequest = app.data.classGuestNotes && app.data.classGuestNotes[v.FolioItemId]
                    v.guestRequest = guestRequest;
                }
                if (v.Category=="Retail") {
                    v.Amount = v.PreDepositAmount;
                }
                newItems.push(v);
            }
            if(v.Category == "PMSPayment"){
                _.each(app.data.pmsBookings,function(pms){
                    if(pms.PMSFolioId == v.FolioId){
                        v.StartDate = pms.ArrivalDate
                        v.FinishDate = pms.DepartureDate
                        v.Location = pms.Venue
                    }
                })

            }
            if(v.Category == "SPAPayment"){
                _.each(app.data.spaBookings,function(spa){
                    if(spa.SpaFolioId == v.FolioId){
                        v.Location = spa.SpaFolioItem.LocationName
                    }
                })

            }
        });
        _.each(golfGrouped, function(v,k,l){
            v.PreDepositAmount = v.Amount;
            v.Amount = (v.FolioPayments == 0) ? v.Amount : v.Amount / v.FolioTotal * v.FolioPayments
            newItems.push(v);
        });
        cartData.WebFolioItem = newItems;
        // grouping services per users
        if(app.customization.features.updatedSummaryPage){
            cartData.WebFolioItem.forEach(function(webFolioItem, idx){
                var CustomerId = webFolioItem.CustomerId || idx;
                cartData.WebFolioItemV2[CustomerId] = cartData.WebFolioItemV2[CustomerId] || { customerName: (webFolioItem.CustomerName || '').replace(',',''), data:[] };
                //Club it is the logged In user or ''
              if(webFolioItem.Category == "Club" && app.data.userLoggedIn)
              cartData.WebFolioItemV2[CustomerId].customerName = app.data.FirstName + ' ' +  app.data.LastName
              cartData.WebFolioItemV2[CustomerId].showUserName = webFolioItem.Category !== "Retail";

            //   removing guestnotes for golf and converting them to individual player names to display instead
            if(webFolioItem.Category === 'Golf'){
                var golfPlayers = webFolioItem.GuestRequest ? JSON.parse(webFolioItem.GuestRequest) : {};
                // webFolioItem.GolfPlayers = Object.values(golfPlayers);
                webFolioItem.GolfPlayers = [];
                _.each(golfPlayers, function(playerName, keyName){
                    if(playerName && keyName !== app.localization.golf.modal.noteName){
                        webFolioItem.GolfPlayers.push(playerName)
                    }
                })
                delete webFolioItem.GuestRequest;
            }
              cartData.WebFolioItemV2[CustomerId].data.push(webFolioItem);
            });
        }
        app.data.breadCrumbs.cart = [{name:app.localization.bookingSummary.cartName,url:"#/summary",last:true}];
        if (Customization.roomsBooking.forceSimple == undefined) {
            Customization.roomsBooking.forceSimple = true;
        }
        var folioTotalAmount = 0;
        var folioTotalWithTax = 0
        var taxAndFee =0;
        var totalsPerFolio = {};
        cartData.WebFolioItem.forEach(function(item){
            if(!totalsPerFolio[item.FolioId]) {
                totalsPerFolio[item.FolioId] = {
                    FolioTotal : item.FolioTotal,
                    taxAndFee : item.FolioSurcharges,
                    subTotal : item.FolioSubtotal
                }
            }
        });

        _.values(totalsPerFolio).forEach(function(item){
            folioTotalAmount += item.subTotal? +item.subTotal:''
            folioTotalWithTax += item.FolioTotal ? +item.FolioTotal:''
            taxAndFee  += +item.taxAndFee
        })
      
        cartData.folioTotalAmount = folioTotalAmount;
        cartData.folioTotalWithTax = folioTotalWithTax;
        cartData.taxAndFee = taxAndFee;

         var services = JSON.parse(JSON.stringify(app.data.serviceTypes))|| []
        if(app.data.clubBookingInCart){
            $.each(services,function(){
                if(this.id != "membership"){
                    this.href = "summary"
                }
            })
            }
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : services,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            services : services,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        //sorts bookings in ascending order by start date/ event date
        function customizedBookingsAscSort (bookings) {
            return Customization.disableChronologicalSortBookingsByModule ?  _.sortBy(bookings, function (booking) { 
                function spaDateStringToDateObj (bookStartTime){
                    var date = bookStartTime.slice(0, -6) + ' ';
                    var time = bookStartTime.slice(-6, -4) + ':' + bookStartTime.slice(-4, -2) ;

                    return new Date(date + time)
                }
                //if is spa, get book start times instead, they do not have date prop
                if(booking.SpaFolioId){
                  if(booking.SpaFolioItem.length){
                    return spaDateStringToDateObj(booking.SpaFolioItem[0].BookStartTime);
                } else {
                    return spaDateStringToDateObj(booking.SpaFolioItem.BookStartTime);
                  }
                }
                return booking.date 
            }): bookings;
        };
        //Filtering and modifying booking to display only cancellable slots
        var modifiedGolfBookings = _.map(app.data.golfBookings, function(golfBooking){
            if(!Array.isArray(golfBooking.GolfPlayer)){
                golfBooking.GolfPlayer = [golfBooking.GolfPlayer]
            };
            return _.extend(golfBooking, {GolfPlayer: _.filter(golfBooking.GolfPlayer, function(player){
                return player.CustomerId && player.CanCancel === 'Y';
            })})
        });
        
        !Customization.moveGuestItineraryToBookingSummaryBottom ?  $('#content').addClass('itineraryToBottom'):''
        $('#content').addClass('cartSummary').html( cartSummaryTpl( {
            Localization : app.localization,
            Customization:app.customization,
            userLoggedIn : app.data.userLoggedIn,
            userLastName: app.data.LastName,
            cartData: cartData,
            service : service,
            serviceTypes : services,
            balance: balance,
            dontShowPayButton: (
                                    (balance == "0.00" || balance == "0")
                                    && (
                                            app.customization.roomsBooking.forcePayment != true
                                            || (
                                                app.customization.payment.skipGuaranteeIfZeroBalanceAndGCUsed
                                                && app.data.redeemedGCs
                                                && app.data.redeemedGCs[app.data.WebFolioId]
                                                && app.data.redeemedGCs[app.data.WebFolioId].length
                                                )
                                        )
                                ) ? 'yes' : 'no',
            dummy: "2000-01-01000000",
            itemCount: !app.customization.showAddMoreOnlyOnBottomOfBookingSummary && cartData && cartData.WebFolioItem && (cartData.WebFolioItem.length >= 5),
            pmsBookings: customizedBookingsAscSort(app.data.pmsBookings),
            spaBookings: customizedBookingsAscSort(app.data.spaBookings),
            golfBookings: customizedBookingsAscSort(modifiedGolfBookings),
            diningBookings: customizedBookingsAscSort(app.data.diningBookings),
            anyFutureBookings: (app.data.pmsBookingFuture && app.data.pmsBookingFuture.length > 0) || (app.data.spaBookingFuture && app.data.spaBookingFuture.length > 0) || (app.data.golfBookingFuture && app.data.golfBookingFuture.length > 0) || (app.data.diningBookingFuture && app.data.diningBookingFuture.length > 0),
            anyPastBookings: (app.data.pmsBookingPast && app.data.pmsBookingPast.length > 0) || (app.data.spaBookingPast && app.data.spaBookingPast.length > 0) || (app.data.golfBookingPast && app.data.golfBookingPast.length > 0) || (app.data.diningBookingPast && app.data.diningBookingPast.length > 0),
            bookingHistoryCollapseHidden: app.data.bookingHistoryCollapseHidden,
            hasRestrictedLogin: app.data.RestrictedLogin,
            guestNoteSpecialService: guestNoteSpecialService,
            noPasswordAndEmail: app.data.folioLoginHasPassword == "N" && app.data.CustomerEmail == "",
            existingEmailAndPassword: app.data.folioLoginHasPassword == "Y" && (typeof app.data.CustomerEmail == 'string'),
            redeemedGCs: app.data.redeemedGCs && app.data.redeemedGCs[app.data.WebFolioId] || [],
            folioSelected: app.data.RestrictedFolio,
            anyGCEnabled: (app.customization.payment.redeemGCbyGCID || app.customization.payment.redeemGCbyGCIDandRefNum)
                            || (app.customization.payment.redeemGCbyGCNum || app.customization.payment.redeemGCbyGCNumandRefNum)
        }));
   
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        if(app.data.clubBookingInCart){
            app.data.messages.push({
                type: 'alert',
                'class': 'alert-error',
                actions: [],
                title: app.localization.club.err['813'],
                message: ''
            });
        }
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        
        commonViewHelper.prepCartSummary();
        commonViewHelper.showMessages();
        if (app.data.pmsBookings) {
            var rates = [],
                roomTypes = [];
            $.each(app.data.pmsBookings,function(i,x){
                if (x.Future) {
                    rates.push(x.PMSRateId);
                    roomTypes.push(x.PMSRoomType)
                }
            });
            rates = _.uniq(rates);
            roomTypes = _.uniq(roomTypes);
            $.each(rates, function(i,x){
                app.dispatcher.dispatch('roomsBooking', 'ratedetails',[x,'updateRateDetails']);
            })
            $.each(roomTypes, function(i,x){
                app.dispatcher.dispatch('roomsBooking', 'roomtypedetails',[x,'updateRoomTypeDetails']);
            })
        }
        app.commonViewHelper.analyticsInit('showCartContents', [cartData])
    });

    cartView.event.listen('showAnalyticsDebugger', cartView, function(e, cartData, folioBalance, customer){
        $('#content').append('<div id="debugAnalyticsModal" class="modal fade" tabindex="-1">\
  <div class="modal-header">\
    <button type="button" class="close" data-dismiss="modal">×</button>\
    <h3>Debug Analytics</h3>\
  </div>\
  <div class="modal-body">\
    <h4><a data-toggle="collapse" href="#collapse-cartData">cartData</a></h4>\
    <div id="collapse-cartData" class="collapse"><pre></pre></div>\
    <h4><a data-toggle="collapse" href="#collapse-folioBalance">folioBalance</a></h4>\
    <div id="collapse-folioBalance" class="collapse"><pre></pre></div>\
    <h4><a data-toggle="collapse" href="#collapse-customer">customer</a></h4>\
    <div id="collapse-customer" class="collapse"><pre></pre></div>\
    <h4><a data-toggle="collapse" href="#collapse-dataLayer">dataLayer</a></h4>\
    <div id="collapse-dataLayer" class="collapse"><pre></pre></div>\
  </div>\
  <div class="modal-footer">\
    <button class="btn" data-dismiss="modal">Close</button>\
  </div>\
</div>')
        $('#collapse-cartData pre').text(JSON.stringify(cartData, null, 2))
        $('#collapse-folioBalance pre').text(JSON.stringify(folioBalance, null, 2))
        $('#collapse-customer pre').text(JSON.stringify(customer, null, 2))
        $('#collapse-dataLayer pre').text(JSON.stringify(window.dataLayer, null, 2))
        $('#debugAnalyticsModal').modal().modal('show').on('hidden', function () { app.dispatcher.redirect('summary','',[]) })
    })
    cartView.event.listen('showAnalytics', cartView, function(e, cartData, folioBalance, customer){
        var golfGrouped = {},
            newItems = [],
            balance = app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId}),
            guestNoteSpecialService = null,
            grandTotal = 0;
        _.each(cartData.WebFolioItem, function(v,k,l){
            if (v.Category=="Golf") {
                if (golfGrouped[v.FolioId]) {
                    golfGrouped[v.FolioId].Amount += +v.Amount;
                    // golfGrouped[v.FolioId].FolioPayments += +v.FolioPayments;
                    golfGrouped[v.FolioId].Players += 1;
                } else {
                    golfGrouped[v.FolioId] = v;
                    golfGrouped[v.FolioId].Players = 1;
                    golfGrouped[v.FolioId].Amount = +v.Amount;
                    golfGrouped[v.FolioId].EachAmount = golfGrouped[v.FolioId].Amount / golfGrouped[v.FolioId].Players;
                    // golfGrouped[v.FolioId].FolioPayments = +v.FolioPayments;
                }

                delete l[k];
                var startDate = Date.parseExact(v.StartDate, "yyyy-MM-ddHHmmss"),
                    today = new Date();
                golfGrouped[v.FolioId].pace = Math.round((startDate-today)/(1000*60*60*24));
                golfGrouped[v.FolioId].startDate = startDate;
            } else {
                if (v.Category=='Ski'&&v.PkgFolioItemId) {
                    var pkgItem = _.find(cartData.WebFolioItem,function(x){return x.FolioItemId==v.PkgFolioItemId&&x.FolioId==v.FolioId&&x.Category=='Ski'})
                    if (pkgItem) {
                        pkgItem.packageItems = pkgItem.packageItems || []
                        pkgItem.packageItems.push(v)
                        delete l[k]
                        return
                    }
                }
                if (v.StartDate) {
                    var startDate = Date.parseExact(v.StartDate, "yyyy-MM-ddHHmmss"),
                        today = new Date();
                    v.pace = Math.round((startDate-today)/(1000*60*60*24));
                    v.startDate = startDate;
                }
                if (v.Category=="Hotel" ) {
                    if( _.any(app.data.pmsDayBookings,function(x){return x==v.FolioId})) {
                        v.isDayBooking = true;
                    }
                    var endDate = Date.parseExact(v.FinishDate, "yyyy-MM-ddHHmmss");
                    v.nights = Math.round((endDate-startDate)/(1000*60*60*24));
                    v.endDate = endDate;
                }
                v.PreDepositAmount = v.FolioTotal;
                if (v.Category=="Spa"||v.Category=="Ski") {
                    v.PreDepositAmount = v.Amount;
                    v.Amount = (v.FolioPayments == 0) ? v.Amount : v.Amount / v.FolioTotal * v.FolioPayments
                }
                grandTotal += +v.PreDepositAmount;
                newItems.push(v);
            }
        });
        _.each(golfGrouped, function(v,k,l){
            v.PreDepositAmount = v.Amount;
            v.Amount = (v.FolioPayments == 0) ? v.Amount : v.Amount / v.FolioTotal * v.FolioPayments
            grandTotal += +v.PreDepositAmount;
            newItems.push(v);
        });
        cartData.WebFolioItem = newItems;
        var itemData = {},
            itemsByCategory = {};
        _.each(newItems, function(v,k,l){
            var sku = (v.Category=='Hotel' ? 'Room-'+v.RateDetails+'-'+v.Details : v.Category+'-'+v.Details);
            if (!!itemData[sku]) {
                var prevPrice = itemData[sku].price,
                    prevQty = itemData[sku].qty,
                    newQty = +prevQty + (v.Category=='Golf' ? +v.Players : 1),
                    newPrice = ((+prevPrice * +prevQty) + ((v.Category=='Golf' ? +v.Players : 1) * (v.Category=='Golf' ? +v.EachAmount : +v.PreDepositAmount)))/(newQty)
                itemData[sku].price = newPrice;
                itemData[sku].qty = newQty;
                if (v.pace && itemData[sku].pace>v.pace) itemData[sku].pace = v.pace;
                if (v.startDate && itemData[sku].startDate>v.startDate) itemData[sku].startDate = v.startDate;
                if (v.endDate && itemData[sku].endDate<v.endDate) itemData[sku].endDate = v.endDate;
                if (v.nights) {
                    itemData[sku].nights += +v.nights;
                    itemData[sku].adr = itemData[sku].price / itemData[sku].nights;
                }
            } else {
                itemData[sku] = {
                    txnid : v.WebFolioId,
                    sku : sku,
                    qty : v.Category=='Golf' ? +v.Players : 1,
                    price : v.Category=='Golf' ? +v.EachAmount : +v.PreDepositAmount,
                    name : v.Category=='Hotel' ? v.RateDetails : v.Details,
                    cat : v.Location,
                    category : v.Category
                }
                if (v.Category=='Hotel') itemData[sku].roomtype = v.Details
                if (v.pace) itemData[sku].pace = v.pace;
                if (v.startDate) itemData[sku].startDate = v.startDate;
                if (v.endDate) itemData[sku].endDate = v.endDate;
                if (v.nights) {
                    itemData[sku].nights = +v.nights;
                    itemData[sku].adr = itemData[sku].price / itemData[sku].nights;
                }
            }
        });
        _.each(itemData, function(v,k,l){
            if (!itemsByCategory[v.Category]) {
                itemsByCategory[v.Category] = _.extend({},v);
                itemsByCategory[v.Category].qty = +v.qty;
                itemsByCategory[v.Category].avgPrice = itemsByCategory[v.Category].total = +v.price;
                if (v.pace && itemsByCategory[v.Category].pace>v.pace) itemsByCategory[v.Category].pace = v.pace;
                if (v.startDate && itemsByCategory[v.Category].startDate>v.startDate) itemsByCategory[v.Category].startDate = v.startDate;
                if (v.endDate && itemsByCategory[v.Category].endDate<v.endDate) itemsByCategory[v.Category].endDate = v.endDate;
                if (v.nights) {
                    itemsByCategory[v.Category].nights = +v.nights;
                    itemsByCategory[v.Category].adr = itemsByCategory[v.Category].total / itemsByCategory[v.Category].nights;
                }
                delete itemsByCategory[v.Category].price;
            } else {
                itemsByCategory[v.Category].total += +v.price;
                itemsByCategory[v.Category].qty += +v.qty;
                itemsByCategory[v.Category].avgPrice = itemsByCategory[v.Category].total / itemsByCategory[v.Category].qty;
                itemsByCategory[v.Category].name = v.name;
                if (v.roomtype) itemsByCategory[v.Category].roomtype = v.roomtype;
                if (v.pace) itemsByCategory[v.Category].pace = v.pace;
                if (v.startDate) itemsByCategory[v.Category].startDate = v.startDate;
                if (v.endDate) itemsByCategory[v.Category].endDate = v.endDate;
                if (v.nights) {
                    itemsByCategory[v.Category].nights += +v.nights;
                    itemsByCategory[v.Category].adr = itemsByCategory[v.Category].total / itemsByCategory[v.Category].nights;
                }
                delete itemsByCategory[v.Category].price;
            }
        });
        app.data.breadCrumbs.cart = [{name:app.localization.bookingSummary.cartName,url:"#/summary",last:true}];
        if (Customization.roomsBooking.forceSimple == undefined) {
            Customization.roomsBooking.forceSimple = true;
        }
        var storeName = '';
        try {
            storeName = cartData.WebFolioItem[0].pmsVenue.PropertyName;
        } catch (e) {
            storeName = app.localization.siteName;
        }
        var tpldata = {
            storeName : storeName,
            Customization:app.customization,
            rawCartData: cartData,
            cartData: _.values(itemData),
            itemsByCategory: _.values(itemsByCategory),
            appData: app.data,
            balance: grandTotal,
            customer: customer,
            customerCity: _.filter(_.uniq(_.pluck($.firstOrOnly(customer.Customer).Address,'City')), function(x){return !!x})[0] || "Unknown",
            customerState: _.filter(_.uniq(_.pluck($.firstOrOnly(customer.Customer).Address,'StateProv')), function(x){return !!x})[0] || "Unknown",
            customerCountry: _.filter(_.uniq(_.pluck($.firstOrOnly(customer.Customer).Address,'Country')), function(x){return !!x})[0] || "Unknown",
            customerPostCode: _.filter(_.uniq(_.pluck($.firstOrOnly(customer.Customer).Address,'PostCode')), function(x){return !!x})[0] || "Unknown"
        };
        try {
            if (app.localization.paymentProcessing.analyticsCustomTemplate) {
                switch (typeof app.localization.paymentProcessing.analyticsCustomTemplate) {
                    case "string":
                        var customTemplateTpl = Handlebars.compile(app.localization.paymentProcessing.analyticsCustomTemplate);
                        tpldata.analyticsCustomTemplate = customTemplateTpl(tpldata);
                        break;
                    case "function":
                        tpldata.analyticsCustomTemplate = app.localization.paymentProcessing.analyticsCustomTemplate.call(this,tpldata);
                        break;
                    default:
                        tpldata.analyticsCustomTemplate = '';
                }
            } else {
                tpldata.analyticsCustomTemplate = '';
            }
        } catch(err) {
            tpldata.analyticsCustomTemplate = '<!--' + err.message + ' -->';
        }
        try {
            $('body').append( analyticsTpl( tpldata ));
        } catch(err) {
            $('body').append( '<!--' + err.message + ' -->' );
        }
    });

    cartView.event.listen('showBookingHistory', cartView, function(e){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        app.data.breadCrumbs.cart = [{name:app.localization.bookingSummary.cartName,url:"#/summary",last:true}];
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        function customizedBookingsDescSort (bookings) {
            
            return Customization.disableChronologicalSortBookingsByModule ? bookings : _.sortBy(bookings, function (booking) {return -booking.date });
        };
        $('#content').addClass('bookingHistory').html( bookingHistoryTpl( {
            Localization : app.localization,
            Customization:app.customization,
            service : service,
            serviceTypes : app.data.serviceTypes,
            pmsBookings: customizedBookingsDescSort (app.data.pmsBookings),
            spaBookings: customizedBookingsDescSort (app.data.spaBookings),
            golfBookings: customizedBookingsDescSort (app.data.golfBookings),
            diningBookings: customizedBookingsDescSort (app.data.diningBookings)
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        if (app.data.pmsBookings) {
            var rates = [],
                roomTypes = [];
            $.each(app.data.pmsBookings,function(i,x){
                if (x.Past) {
                    rates.push(x.PMSRateId);
                    roomTypes.push(x.PMSRoomType)
                }
            });
            rates = _.uniq(rates);
            roomTypes = _.uniq(roomTypes);
            $.each(rates, function(i,x){
                app.dispatcher.dispatch('roomsBooking', 'ratedetails',[x,'updateRateDetails']);
            })
            $.each(roomTypes, function(i,x){
                app.dispatcher.dispatch('roomsBooking', 'roomtypedetails',[x,'updateRoomTypeDetails']);
            })
        }
    });

    cartView.event.listen('updateMessages', cartView, function(e){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        $('#alerts .alert').remove()
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        $('#cartCCFormSubmit').button('reset');
    });

    cartView.event.listen('showCCPaymentForm', cartView, function(e, cartData){
            var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        var years = [],
            thisYear = +Date.today().toString("yyyy");
        for (i=0; i<10; i++) {
            years.push(thisYear + i);
        }
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/ccPayment",last:true}];
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        $('#content').addClass('cartCCPaymentForm').html( cartCCPaymentFormTpl ( {
            Localization: app.localization,
            Customization: app.customization,
            cartData: cartData,
            service : service,
            serviceTypes : app.data.serviceTypes,
            FirstName: app.data.FirstName,
            LastName: app.data.LastName,
            email: app.data.CustomerEmail,
            balance: app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId}),
            years: years,
            dummy: "2000-01-01000000"
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.prepCCPaymentForm();
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.populateReturnStatementText();
    });

    cartView.event.listen('showRedeemGCForm', cartView, function(e, cartData){
            var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        var years = [],
            thisYear = +Date.today().toString("yyyy");
        for (i=0; i<10; i++) {
            years.push(thisYear + i);
        }
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.gcRedeemTitle,url:"#/summary/redeemGC",last:true}];
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        $('#content').addClass('cartGCRedeem').html( cartGCRedeemTpl ( {
            Localization: app.localization,
            Customization: app.customization,
            bothGCTypes: (app.customization.payment.redeemGCbyGCID || app.customization.payment.redeemGCbyGCIDandRefNum)
                            && (app.customization.payment.redeemGCbyGCNum || app.customization.payment.redeemGCbyGCNumandRefNum),
            eitherGCTypeID: app.customization.payment.redeemGCbyGCID || app.customization.payment.redeemGCbyGCIDandRefNum,
            eitherGCTypeNum: app.customization.payment.redeemGCbyGCNum || app.customization.payment.redeemGCbyGCNumandRefNum
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.prepRedeemGCForm();
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
    });

    cartView.event.listen('showCCPaymentResult', cartView, function(e, cartData){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/",last:true}];
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        $('#content').addClass('cartCCPaymentResult').html( cartCCPaymentResultTpl ( {
            Localization: app.localization,
            Customization: app.customization,
            cartData: cartData,
            service : service,
            serviceTypes : app.data.serviceTypes,
            FirstName: app.data.FirstName,
            LastName: app.data.LastName,
            email: app.data.CustomerEmail,
            balance: app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId}),
            dummy: "2000-01-01000000"
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.prepCCPaymentForm();
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
    });

    cartView.event.listen('processingPPPayment', cartView, function(e){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/",last:true}];
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.paymentProcessing.sectionTitle,
            siteName : app.localization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        $('#content').addClass('processingPPPayment').html( processingPPPaymentTpl ( {
            Localization: app.localization,
            Customization: app.customization
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.showPPProgressIndicator(app.localization.paymentProcessing.PPPostRedirect);
    });


    cartView.event.listen('showPPProgressIndicator', cartView, function(e,message){
        commonViewHelper.showPPProgressIndicator(message);
    });

    cartView.event.listen('showYPForm', cartView, function(e, cartData){
            var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };

        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/ypPayment",last:true}];
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : Customization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization : app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : Customization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        $('#content').addClass('cartYPForm').html( cartYPFormTpl ( {
            Localization: app.localization,
            Customization: $.extend({},app.customization, {requirePaymentAddress:true}), // force requirepaymentaddress to be true so that form requires the fields.
            cartData: cartData,
            service : service,
            serviceTypes : app.data.serviceTypes,
            FirstName: app.data.FirstName,
            LastName: app.data.LastName,
            email: app.data.CustomerEmail,
            balance: app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId}),
            dummy: "2000-01-01000000"
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.prepYPForm();
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.showMessages();
        commonViewHelper.populateReturnStatementText();
    });

    cartView.event.listen('redirectYP', cartView, function(e, mid,mtr,digest,currency,forwardURL,successURL,failURL,amount,cartData){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        cartData.WebFolioItem
            && (cartData.WebFolioItem = _.map(cartData.WebFolioItem,function(v,k){
                v.key = k+1;
                v.Amount = ((+v.Amount)*100).toFixed(0).toString();
                v.FolioSurcharges = ((+v.FolioSurcharges)*100).toFixed(0).toString();
                return v
            }));
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/ypPayment",last:true}];
        $('#main').html( contentTpl( {
            Localization : app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : Customization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        $('#content').addClass('redirectYP').html( redirectYPTpl ( {
            mid:mid,
            WebFolioId: app.data.WebFolioId,
			mtr:mtr,
            digest:digest,
            amount: Math.round(amount*100),
            currency:currency,
            forwardURL:forwardURL,
            email: app.data.CustomerEmail,
            successURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            failURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            cartData: cartData
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.redirectYP();
        commonViewHelper.showMessages();
        commonViewHelper.populateReturnStatementText();
    });

    cartView.event.listen('redirectPaytm', cartView, function(e, forwardURL,request_type,mid,order_id,cust_id,txn_amount,channel_id,industry_type_id,website,mobile_no,email_id,checksumhash,callback_url,amount,cartData){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        // cartData.WebFolioItem
        //     && (cartData.WebFolioItem = _.map(cartData.WebFolioItem,function(v,k){
        //         v.key = k+1;
        //         v.Amount = ((+v.Amount)*100).toFixed(0).toString();
        //         v.FolioSurcharges = ((+v.FolioSurcharges)*100).toFixed(0).toString();
        //         return v
        //     }));
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/paytmPayment",last:true}];
        $('#main').html( contentTpl( {
            Localization : app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : Customization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        $('#content').addClass('redirectPaytm').html( redirectPaytmTpl ( {
            forwardURL: forwardURL,
            request_type: request_type,
            mid: mid,
            order_id: order_id,
            cust_id: cust_id,
            txn_amount: txn_amount,
            channel_id: channel_id,
            industry_type_id: industry_type_id,
            website: website,
            mobile_no: mobile_no,
            email_id: email_id,
            checksumhash: checksumhash,
            callback_url: callback_url,
            WebFolioId: app.data.WebFolioId,
            successURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            failURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            cartData: cartData
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.redirectPaytm();
        commonViewHelper.showMessages();
        commonViewHelper.populateReturnStatementText();
    });

    cartView.event.listen('redirectI4G', cartView, function(e,forwardURL,accessBlock,server,allowStoreCard){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/i4gPayment",last:true}];
        // $('#acceptTermsModal, .I4GModalElems').remove();
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : Customization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization: app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : Customization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        var balance= app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId});
        $('#content').addClass('redirectI4G').html( redirectI4GTpl ( {
            Localization: app.localization,
            balance: balance,
            forwardURL:forwardURL,
            accessBlock:accessBlock,
            server:server,
            allowStoreCard:allowStoreCard=='Y',
            balanceGTZero:(+balance > 0), // do not ask user whether to store their CC on file if balance equals zero, which we assume means they're not paying a deposit and we *need* to store the card
            successURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            failURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            Customization: app.customization,
            // cartData: cartData,
            service : service,
            serviceTypes : app.data.serviceTypes,
            FirstName: app.data.FirstName,
            LastName: app.data.LastName,
            email: app.data.CustomerEmail,
            dummy: "2000-01-01000000"
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.redirectI4G(forwardURL,accessBlock);
        commonViewHelper.showMessages();
        commonViewHelper.populateReturnStatementText();
    });

    cartView.event.listen('redirect3DS', cartView, function(e,forwardURL,params){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/wpPayment",last:true}];
        // $('#acceptTermsModal, .I4GModalElems').remove();
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : Customization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization: app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : Customization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        $('#content').addClass('redirect3DS').html( redirect3DSTpl ( {
            Localization: app.localization,
            balance: app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId}),
            forwardURL:forwardURL,
            fields:params,
            successURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            failURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            Customization: app.customization,
            // cartData: cartData,
            service : service,
            serviceTypes : app.data.serviceTypes,
            FirstName: app.data.FirstName,
            LastName: app.data.LastName,
            email: app.data.CustomerEmail,
            dummy: "2000-01-01000000"
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.redirect3DS(forwardURL,params);
        commonViewHelper.showMessages();
        commonViewHelper.populateReturnStatementText();
    });

    cartView.event.listen('redirectWP', cartView, function(e,forwardURL,clientKey,allowStoreCard){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/wpPayment",last:true}];
        // $('#acceptTermsModal, .I4GModalElems').remove();
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : Customization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization: app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : Customization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        var balance= app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId});
        $('#content').addClass('redirectWP').html( redirectWPTpl ( {
            Localization: app.localization,
            balance: balance,
            forwardURL:forwardURL,
            clientKey:clientKey,
            allowStoreCard:allowStoreCard=='Y',
            balanceGTZero:(+balance > 0), // do not ask user whether to store their CC on file if balance equals zero, which we assume means they're not paying a deposit and we *need* to store the card
            successURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            failURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            Customization: app.customization,
            // cartData: cartData,
            service : service,
            serviceTypes : app.data.serviceTypes,
            FirstName: app.data.FirstName,
            LastName: app.data.LastName,
            email: app.data.CustomerEmail,
            dummy: "2000-01-01000000"
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.redirectWP(forwardURL,clientKey);
        commonViewHelper.showMessages();
        commonViewHelper.populateReturnStatementText();
    });

    cartView.event.listen('redirectSQ', cartView, function(e,applicationId,forwardURL,locationId,threeDSEnabled,paymentAmount,allowStoreCard,currencyCode){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/sqPayment",last:true}];
        // $('#acceptTermsModal, .I4GModalElems').remove();
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : Customization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization: app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : Customization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        var balance= app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId});
        $('#content').addClass('redirectSQ').html( redirectSQTpl ( {
            Localization: app.localization,
            balance: balance,
//             forwardURL:forwardURL,
//             clientKey:clientKey,
            allowStoreCard:allowStoreCard=='Y',
            balanceGTZero:(+balance > 0), // do not ask user whether to store their CC on file if balance equals zero, which we assume means they're not paying a deposit and we *need* to store the card
            successURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            failURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            Customization: app.customization,
            // cartData: cartData,
            service : service,
            serviceTypes : app.data.serviceTypes,
            FirstName: app.data.FirstName,
            LastName: app.data.LastName,
            email: app.data.CustomerEmail,
            dummy: "2000-01-01000000"
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.redirectSQ(applicationId,forwardURL,locationId,threeDSEnabled,paymentAmount,allowStoreCard,currencyCode);
        commonViewHelper.showMessages();
        commonViewHelper.populateReturnStatementText();
    });
    cartView.event.listen('redirect3C', cartView, function(e,forwardURL,allowStoreCard,paymentAmount,threeDSEnabled,threeCSession){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/3cPayment",last:true}];
        // $('#acceptTermsModal, .I4GModalElems').remove();
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : Customization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization: app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : Customization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        var balance= app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId});
        $('#content').addClass('redirect3C').html( redirect3CTpl ( {
            Localization: app.localization,
            balance: balance,
// forwardURL,allowStoreCard,paymentAmount,threeDSEnabled,threeCSession
            allowStoreCard:allowStoreCard=='Y',
            
            balanceGTZero:(+balance > 0), // do not ask user whether to store their CC on file if balance equals zero, which we assume means they're not paying a deposit and we *need* to store the card
            successURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            failURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            Customization: app.customization,
            // cartData: cartData,
            service : service,
            serviceTypes : app.data.serviceTypes,
            FirstName: app.data.FirstName,
            LastName: app.data.LastName,
            email: app.data.CustomerEmail,
            dummy: "2000-01-01000000"
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.redirect3C(forwardURL,allowStoreCard,paymentAmount,threeDSEnabled,threeCSession);
        commonViewHelper.showMessages();
        commonViewHelper.populateReturnStatementText();
    });

    cartView.event.listen('redirectFP', cartView, function(e,forwardURL,allowStoreCard,paymentamount,threedsenabled,applepayenabled,googlepayenabled,samsungpayenabled,paypalenabled){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        app.data.breadCrumbs.cart = [{name:app.localization.paymentProcessing.sectionTitle,url:"#/summary/sqPayment",last:true}];
        // $('#acceptTermsModal, .I4GModalElems').remove();
        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : Customization.siteName,
            backLink : Customization.serverURL
        }) );
        $('#main').html( contentTpl( {
            Localization: app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : Customization.siteName,
            backLink : Customization.serverURL,
            service : service
        }) );
        var balance= app.models.systemModel.getSelectedValue('folioBalance','FolioBalance',{WebFolioId:app.data.WebFolioId,SessionId:app.data.SessionId});
        $('#content').addClass('redirectFP').html( redirectFPTpl ( {
            Localization: app.localization,
            balance: balance,
            forwardURL:forwardURL,
            paymentamount:paymentamount,
            threedsenabled:threedsenabled,
            applepayenabled:applepayenabled,
            googlepayenabled:googlepayenabled,
            samsungpayenabled:samsungpayenabled,
            paypalenabled:paypalenabled,
            allowStoreCard:allowStoreCard=='Y',
            balanceGTZero:(+balance > 0), // do not ask user whether to store their CC on file if balance equals zero, which we assume means they're not paying a deposit and we *need* to store the card
            successURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            failURL:window.location.protocol + '//' + window.location.host + window.location.pathname,
            Customization: app.customization,
            // cartData: cartData,
            service : service,
            serviceTypes : app.data.serviceTypes,
            FirstName: app.data.FirstName,
            LastName: app.data.LastName,
            email: app.data.CustomerEmail,
            dummy: "2000-01-01000000"
        }));
        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) )
        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);
        commonViewHelper.redirectFP(forwardURL,allowStoreCard,paymentamount,threedsenabled,applepayenabled,googlepayenabled,samsungpayenabled,paypalenabled);
        commonViewHelper.showMessages();
        commonViewHelper.populateReturnStatementText();
    });

    cartView.event.listen('showTermsModal', cartView, function(e, isGuest){
        $('#acceptTermsModal').remove();
        $('#main').append(acceptTermsModalTpl({
            Localization : app.localization
        }));
        commonViewHelper.prepTermsModal(isGuest);
    });

    cartView.event.listen('renderERegForm', cartView, function(e, venueName, pmsFolioId,lastname){
        var service = {
            id : "summary",
            icon : "ok",
            name : app.localization.general.serviceButtonLabel
        };
        app.data.breadCrumbs.cart = [{name:app.localization.eReg.summarySectionTitle, url:'#/summary'}, {name:app.localization.eReg.sectionTitle, last:true}];

        

        $('#nav').html( navbarTpl( {
            Customization:app.customization,
            Localization : app.localization,
            services : app.data.serviceTypes,
            languages : app.data.languageNames,
            siteName : Customization.siteName,
            backLink : Customization.serverURL
        }));

        $('#main').html( contentTpl( {
            Localization: app.localization,
            services : app.data.serviceTypes,
            bannerMessage : app.localization.bookingSummary.marketing.bannerMessage,
            siteName : Customization.siteName,
            backLink : Customization.serverURL,
        }) );

        $('#breadcrumbs').html( breadcrumbsTpl({
            'breadCrumbs':app.data.breadCrumbs.cart
        }) );

        $('body').removeClass (function (index, css) {
            return (css.match (/(^|\s)content-\S+/g) || []).join(' ');
        });
        $('body').addClass('content-eRegTpl')

        commonViewHelper.updateNavBar(service,app.language,app.models.systemModel.dataModel.folioBalance.data[app.models.systemModel.makeStandardName(app.models.systemModel.dataModel.folioBalance,{})]);

        

        $('body #content').empty().append('<div class="vue-eReg-container"><div id="vue-app-e-reg" /></div>');
        require(['app/views/vue/e-reg-vue-app/starter'], function (starter) {
            if(app.data.eRegVueAppRef) app.data.eRegVueAppRef.$destroy();
            starter({venueName: venueName, pmsFolioId: pmsFolioId,lastName:lastname});
            $('#progressIndicator').modal('hide');
        });
    });

    return window.app.views.cartView = cartView;

});

